<template>
  <div class="DiscountPriceContainer">
    <div class="pd16 box colFlex">
      <nut-row class="bothCenter">
        <img src="https://cdn.waityou.online/10f633ed-8e73-1d24-58a7-a9f372e0fd35.png"
             style="height: 25px"/>
      </nut-row>
      <nut-row class="bothCenter mt12">
        <nut-col :span="12" class="leftCenter">
          <span class="lightText">课程价</span>
        </nut-col>
        <nut-col :span="12" class="rightCenter">
          <span>¥{{originalPrice}}</span>
        </nut-col>
      </nut-row>
      <div class="divider vmg8"></div>
      <nut-row class="bothCenter">
        <nut-col :span="12" class="leftCenter">
          <span class="lightText">学习红包</span>
        </nut-col>
        <nut-col :span="12" class="rightCenter">
          <span>-¥{{discount}}</span>
        </nut-col>
      </nut-row>
      <div class="divider vmg8"></div>
      <nut-row class="bothCenter">
        <nut-col :span="12" class="leftCenter">
          <span>限时最低价</span>
        </nut-col>
        <nut-col :span="12" class="rightCenter">
          <span class="darkNumberText boldFont">¥{{ (originalPrice-discount).toFixed(2) }}</span>
        </nut-col>
      </nut-row>
    </div>
    <nut-row class="bothCenter wd100 buyNow pd16 box">
      <nut-col :span="14" class="wft">
        <span class="ft18">限时仅需:</span>
        <span class="ft20">¥&nbsp;</span>
        <span class="ft36">{{ (originalPrice-discount).toFixed(2) }}</span>
      </nut-col>
      <nut-col :span="10" class="rightCenter">
        <button class="buyNowBtn" @click="$emit('buy')">立即报名</button>
      </nut-col>
    </nut-row>
  </div>
</template>

<script>
export default {
  name: "DiscountPrice",
  props: {
    originalPrice: {
      type: Number,
      default: 0
    },
    discount: {
      type: Number,
      default: 0
    },
  },
  methods: {
    init() {

    }
  },
  mounted() {
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.DiscountPriceContainer {
  display: flex;
  flex-direction: column;
  background-color: white;

  .buyNow{
    background-image: url("https://cdn.waityou.online/aefdb113-88c3-21b9-0abd-99dc7247cdf9.png");
    background-repeat: no-repeat;
    background-size: 200%;
    background-position: center;

    .buyNowBtn{
      background: white;
      color: #E76A2C;
      border: none;
      padding:10px 24px;
      border-radius: 30px;
      font-size: 20px;
      font-weight: bold;
    }
  }
}
</style>